// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"38150f94","598":"bb72f29c","703":"c70bee3a","787":"bacccd76"}[chunkId] + ".chunk.js";
};